<div class="planning-trip">
  @for (field of field.fieldGroup; track field.key) {
    <formly-field [field]="field" class="w-100" />
  }
</div>
